<template>
  <div class="d-flex flex-column align-center justify-center w-100 h-100">
    <!-- Image inside the slot of progress-linear -->

    <div
      class="mt-n10"
      :style="{
        width: is_mobile ? `${width / 2}px` : `${width}px`,
        height: is_mobile ? `${height / 2}px` : `${height}px`,
      }"
    >
      <!-- Every layout mounts its own loader: the cached logo paints at once
           instead of fading in again on each route change. -->
      <v-img
        v-if="image"
        :src="`${configdata.url.cdn}/pages/${mainStore.companypage.logo}`"
        :transition="false"
        eager
        contain
        class="mb-10"
      ></v-img>
      <v-progress-linear
        :width="is_mobile ? circle_size / 2 : circle_size"
        indeterminate
        color="var(--company-primary) "
      >
      </v-progress-linear>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/store";
import config from "@/config";
import isMobile from "@/mixins/isMobile";

export default {
  mixins: [isMobile],
  data: () => ({
    mainStore: useMainStore(),
  }),
  props: {
    image: Boolean,
    circle_size: Number,
    width: Number,
    height: Number,
  },
  computed: {
    configdata() {
      return config;
    },
  },
};
</script>
